export var ENTITY = "template document";
export var REDUCER_KEY = "TEMPLATE_DOCUMENTS_V2";
export var BASE_PATH_ENTITY = "template-documents";
export var GENERATOR_PARAMS = {
    entity: ENTITY,
    reducerKey: REDUCER_KEY,
    basePathEntity: BASE_PATH_ENTITY,
};
